<template>
  <div class="thanks-page">
    <div class="thanks-card">
      <div class="check-icon">
        <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
          <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
      </div>
      <h1>Tack för ditt köp!</h1>
      <p class="lead">
        Beställningen är registrerad. Du får ett mail från Stripe med
        kvitto inom någon minut.
      </p>
      <p>
        Vi trycker och skickar din t-shirt så snart som möjligt — räkna med
        leverans inom <strong>3–5 vardagar</strong> i Sverige. Du får en
        separat tracking-länk när paketet är på väg.
      </p>
      <p class="muted">
        Frågor? Maila <a href="mailto:hello@livegbg.se">hello@livegbg.se</a>
      </p>

      <router-link to="/" class="back-btn">Tillbaka till konserter</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "MerchThanks",
};
</script>

<style scoped>
.thanks-page {
  min-height: calc(100vh - 84px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.5rem;
}

.thanks-card {
  max-width: 520px;
  text-align: center;
  padding: 3rem 2rem;
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: 8px;
}

.check-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: var(--color-accent);
  color: #fff;
  margin-bottom: 1.5rem;
}

h1 {
  font-family: "Playfair Display", serif;
  font-size: 2rem;
  font-weight: 900;
  line-height: 1.1;
  margin: 0 0 0.75rem;
  text-transform: uppercase;
  letter-spacing: -0.01em;
}

p {
  margin: 0 0 1rem;
  color: var(--color-text-secondary);
  line-height: 1.6;
}

.lead {
  font-size: 1.05rem;
  color: var(--color-text);
}

.muted {
  font-size: 0.85rem;
  margin-top: 1.5rem;
}

.muted a {
  color: var(--color-accent);
  text-decoration: none;
}

.muted a:hover {
  text-decoration: underline;
}

.back-btn {
  display: inline-block;
  margin-top: 2rem;
  padding: 0.75rem 1.5rem;
  background: transparent;
  border: 1px solid var(--color-text);
  color: var(--color-text);
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  border-radius: 4px;
  transition: background 0.15s ease, color 0.15s ease;
}

.back-btn:hover {
  background: var(--color-text);
  color: var(--color-bg);
}
</style>
